<template>
  <v-snackbar
    v-model="model"
    :color="snackbar.type"
    :timeout="snackbar.timeout"
  >
    <v-icon
      :dark="snackbar.type !== 'warning'"
      class="mr-2 white--text"
      v-text="icon"
    />
    <span
      class="white--text"
      v-text="snackbar.msg"
    />
  </v-snackbar>
</template>

<script>
  // Utilities
  import {
    mapState
  } from 'vuex'

// b40eef07-763c-4da7-b083-764256b52b27
// 42a393f9-8553-4e4a-a9bc-d3cc4402028e
  export default {
    data: () => ({
      model: false
    }),

    computed: {
      ...mapState(['snackbar','icons']),
      icon () {
        return this.icons[this.snackbar.type] || this.icons.checkon
      }
    },

    watch: {
      snackbar () {
        this.model = true
      }
    }
  }
</script>
